import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ScorecardComponent } from "./scorecard.component";
import { ScorecardTabComponent } from "./scorecard-tab.component";
import { ContextGraphButtonComponent } from "../analysis/context-graph-button.component";
import { EditInModelComponent, HeldAsFixComponent, SystemKindFixComponent, ValueFixComponent } from "../analysis/node-fixes.component";
import { MaterialModule } from "../material/material.module";


@NgModule({
  declarations: [
    ScorecardComponent,
    ScorecardTabComponent,
  ],
  exports: [
    ScorecardComponent,
    ScorecardTabComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ContextGraphButtonComponent,
    EditInModelComponent,
    HeldAsFixComponent,
    SystemKindFixComponent,
    ValueFixComponent,
  ],
  providers: [
  ]
})
export class EPMModule { }
